import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { toast } from "react-toastify";

import * as settingsActions from "store/entities/settingsInfo/action";

import FormDrawer from 'components/__new/common/form-drawer';
import ViewRoleModal from "components/__new/common/form/ViewRolePermission";
import { ButtonLoader, Input, SelectInput } from "components/__new/common/form";
import validate from "utils/validate";
import {ReactComponent as TransferFolder} from "assets/images/icons/transfer-folder.svg";
import {ReactComponent as Caution} from "assets/images/icons/orange-caution.svg";
import ModalAlert from 'components/__new/common/ModalAlert';
import { nameInitials } from 'utils/nameInitials';




const TransferOwnershipModal = (props) => {
const {isOpen, setIsOpen, data: members} = props;
const dispatch = useDispatch()
const { transferOwnershipLoading, transferOwnership  } = useSelector(state => state.entities.settingsInfo)

const [isCreated, setIsCreated] = useState(false)
const [isOpenModalAlertSuccess , setIsOpenModalAlertSuccess] = useState()

const [form, setForm] = useState({
    memberId: "",
});

const submitForm = async (e) => {
    e.preventDefault();
    
    // const validateForm = {...form};
    //     delete validateForm["role"];
    
    const errors = validate(form);
    if (errors){
        for (var x in errors) {
            toast.error(errors[x]);
        };
        return;
    }
    else{
      dispatch(settingsActions.transferOwnership(form.memberId))
      setIsCreated(true)
    }
}


useEffect(() => {
    if(transferOwnership?.error === false && isCreated ){
        setIsOpenModalAlertSuccess(true)
        setIsCreated(false)
        
    }
}, [transferOwnership?.error, isCreated]);

const filteredMembers = members?.filter((member) => (member.role?.name !== "Owner" && member?.status === "active"))

    return (
    <>
    <ModalAlert
                successText={transferOwnership?.message}
                dismissText="Close"
                isOpenModalAlert={isOpenModalAlertSuccess}
                setIsOpenModalAlert={setIsOpenModalAlertSuccess}
            />
    <FormDrawer display="center" size="lg" isOpen={isOpen} setIsOpen={setIsOpen}>
            <section className="p-6">
                <FormDrawer.Title
                    title="Transfer Ownership"
                    showCloseButton={true}
                    close={setIsOpen}
                />
                <form onSubmit={submitForm} >
                    <main>
                      <div className="mt-6 mx-auto">
                        <TransferFolder
                          className='text-center block mx-auto'
                        />
                      </div>
                      <div className="mt-6 mb-4 bg-ep-banner py-3 px-4 rounded-[8px] flex items-center">
                                  <Caution className="w-[13.33px] h-[13.33px] mr-2" alt="caution" />
                                  <span className="flex-1 text-sm">Please note that your access and permissions will revert to an admin role once ownership is transferred.</span>
                        </div>
                      <SelectInput label="Who are you transferring to?" name="memberId" required={true} value={form.memberId} onChange={(e) => setForm({memberId: e.target.value})}>
                          <option value="">Select a team member</option>
                          {filteredMembers?.map(member => (
                              <option key={member.id} value={member.id} className='flex gap-2'>
                                  {member.firstName + ' ' + member.lastName}
                                {/* <span className='p-3 rounded-full bg-ep-primary text-white'>
                                  <span>{nameInitials(member.firstName, member.lastName)}</span>
                                </span> 
                                <span>
                                  {member.firstName + ' ' + member.lastName}
                                </span> */}
                              </option>
                          ))}
                      </SelectInput>
                      
                    </main>
                    <footer className="p-1 mt-4 flex justify-end space-x-3">
                        <div className='flex'>
                            <div className='pr-5'>
                                <button onClick={setIsOpen} type="button" className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-ep-primary-600 bg-white"                    >
                                    Cancel
                                </button>
                            </div>
                            <div>
                                <ButtonLoader type="submit" loading={transferOwnershipLoading} className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-white bg-ep-primary-600">
                                    Continue
                                </ButtonLoader>
                            </div>
                        </div>
                    </footer>    
                </form>
            </section>
        </FormDrawer>
    </>
  )
}

export default TransferOwnershipModal
